/**
 * Converts UTC date string to user's local timezone
 * @param {string} utcDateString - UTC date string
 * @returns {Date|null} - Local date object or null if invalid
 */
export const convertUTCToLocal = (utcDateString) => {
  if (!utcDateString) return null;

  try {
    const date = new Date(utcDateString);
    // Check if the date is valid
    if (isNaN(date.getTime())) {

      return null;
    }
    return date;
  } catch (error) {
    return null;
  }
};

/**
 * Checks if the current time is within the maintenance window
 * @param {string} startDate - UTC start date string
 * @param {string} endDate - UTC end date string
 * @returns {boolean} - True if current time is within maintenance window
 */
export const isWithinMaintenanceWindow = (startDate, endDate) => {
  if (!startDate || !endDate) return false;

  try {
    const now = new Date();
    const localStart = convertUTCToLocal(startDate);
    const localEnd = convertUTCToLocal(endDate);

    if (!localStart || !localEnd) return false;

    return now >= localStart && now <= localEnd;
  } catch (error) {
    return false;
  }
};

/**
 * Checks if the current time is before the maintenance window starts
 * @param {string} startDate - UTC start date string
 * @returns {boolean} - True if current time is before maintenance window
 */
export const isBeforeMaintenanceWindow = (startDate) => {
  if (!startDate) return false;

  try {
    const now = new Date();
    const localStart = convertUTCToLocal(startDate);

    if (!localStart) return false;

    return now < localStart;
  } catch (error) {
    return false;
  }
};

/**
 * Checks if the current time is after the maintenance window ends
 * @param {string} endDate - UTC end date string
 * @returns {boolean} - True if current time is after maintenance window
 */
export const isAfterMaintenanceWindow = (endDate) => {
  if (!endDate) return false;

  try {
    const now = new Date();
    const localEnd = convertUTCToLocal(endDate);

    if (!localEnd) return false;

    return now > localEnd;
  } catch (error) {
    return false;
  }
};
